import { sendPost, sendPostDisplayNames } from "src/utils/sendApi";

export const getDisplayNames = sendPost("v1/data/_inventory/_display_names")

export const getFilterDisplayNamesApi = sendPost("v1/data/_filter_disp_names")

export const configsApi = sendPost("v1/data/_configs")

export const getIngredientsCount = sendPost("v1/data/_inventory/_ingredients_count")

export const rustyDisplayNames = sendPostDisplayNames("v1/data/display-names")